import { Component, OnInit, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DarSettings,
  DpcSettings,
  BobaSettings,
  DpcVmSettings,
  SaasStorageSettings,
  AtlasSettings,
} from "@kelyn-technologies/dsio-angular-lib";
import { MatSnackBarModule, MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "solutions-wizard",
  templateUrl: "./solutions-wizard.component.html",
  imports: [CommonModule, MatSnackBarModule],
  styleUrls: ["./solutions-wizard.component.css"],
})
export class SolutionsWizardComponent implements OnInit {
  @Input() public solutionId = "";
  public formInputs = {};

  constructor(public snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.formInputs = {
      solutionId: this.solutionId,
      ...(["DAR", "DARL"].includes(this.solutionId)
        ? { allowArchitectureOverride: false } : {}),
      snackBar: this.snackBar,
      returnRoute: `/gateway/home/solutions`,
    };
  }

  getContainer() {
    switch (this.solutionId) {
      case "DAR":
        return DarSettings;
      case "DARL":
        return DarSettings;
      case "DPC":
        return DpcSettings;
      case "BOBA":
        return BobaSettings;
      case "DPC_VM_BACKUP":
        return DpcVmSettings;
      case "DSIO_SAAS_STORAGE":
        return SaasStorageSettings;
      case "ATLAS":
        return AtlasSettings;
      default:
        return null;
    }
  }
}
